import React from 'react';
import { useTheme } from '../context/ThemeContext';

const InfoCard = ({ icon, label, value, valueColor = 'text-gray-900', onClick }) => {
  const { colors } = useTheme();
  const isInteractive = typeof onClick === 'function';

  const handleKeyDown = (event) => {
    if (!isInteractive) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  const commonProps = isInteractive
    ? {
      role: 'button',
      tabIndex: 0,
      onClick,
      onKeyDown: handleKeyDown,
      className:
        'rounded-lg p-[16px] transition-transform hover:-translate-y-[2px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF6B35] cursor-pointer',
    }
    : {
      className: 'rounded-lg p-[16px]',
    };

  return (
    <div
      {...commonProps}
      style={{
        backgroundColor: colors.background,
        border: `1px dashed ${colors.border}`,
        borderImageSource:
          `repeating-linear-gradient(0deg, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px), repeating-linear-gradient(90deg, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px), repeating-linear-gradient(180deg, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px), repeating-linear-gradient(270deg, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px)`,
        borderImageSlice: 1,
      }}
    >
      <div className="flex items-center text-[18px] mb-0" style={{ color: colors.textSecondary }}>
        {icon}
        <span>{label}</span>
      </div>
      <div className={`text-[36px] font-black leading-none`} style={{ color: valueColor.startsWith('#') ? valueColor : colors.textPrimary }}>{value}</div>
    </div>
  );
};

export default InfoCard;
